import { Link } from 'react-router-dom';

const paragraphs = [
  {
    text: "Modern nomad living is a lifestyle revolution. It's the conscious choice to break free from conventional housing and embrace a life of flexibility, simplicity, and connection with nature. Whether you're drawn to the open road in a converted van, the self-sufficiency of an off-grid cabin, the gentle sway of a liveaboard boat, or the pure freedom of camping under the stars — this movement is about designing life on your own terms.",
    links: []
  },
  {
    text: "More than just a trend, it represents a fundamental shift in how people think about home, work, and what truly matters. With remote work becoming the norm and housing costs soaring, millions are discovering that the best address might be no fixed address at all. The modern nomad doesn't sacrifice comfort for freedom — they've learned to have both.",
    links: [
      { text: "van life basics", url: "/article/van-life-basics-complete-guide" },
      { text: "off-grid living", url: "/article/off-grid-living-basics-complete-guide" }
    ]
  },
  {
    text: "This isn't about escaping reality. It's about creating a richer one. A life where you wake up to new views, where your neighbors are fellow adventurers, and where every day holds the possibility of discovery. Welcome to Modern Nomad Living — your guide to alternative living done right.",
    links: [
      { text: "boat living", url: "/article/boat-living-basics-complete-guide" },
      { text: "camping", url: "/article/camping-basics-complete-guide" }
    ]
  }
];

export const WhatIsSection = () => {
  const renderParagraphWithLinks = (paragraph: { text: string; links: { text: string; url: string }[] }, index: number) => {
    if (paragraph.links.length === 0) {
      return (
        <p 
          key={index} 
          className="text-lg leading-[1.8] animate-fade-in"
          style={{ animationDelay: `${index * 150}ms` }}
        >
          {paragraph.text}
        </p>
      );
    }

    const linkElements = paragraph.links.map((link, linkIndex) => (
      <span key={linkIndex}>
        {linkIndex > 0 && ' and '}
        <Link 
          to={link.url} 
          className="text-accent hover:text-accent/80 underline underline-offset-2 transition-colors"
        >
          {link.text}
        </Link>
      </span>
    ));

    return (
      <p 
        key={index} 
        className="text-lg leading-[1.8] animate-fade-in"
        style={{ animationDelay: `${index * 150}ms` }}
      >
        {paragraph.text}
        {paragraph.links.length > 0 && (
          <span className="block mt-2 text-base text-muted-foreground">
            Learn more: {linkElements}
          </span>
        )}
      </p>
    );
  };

  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-primary text-center mb-10">
          What is Modern Nomad Living?
        </h2>
        <div className="prose prose-lg mx-auto text-foreground/85 leading-relaxed space-y-6">
          {paragraphs.map((paragraph, index) => 
            renderParagraphWithLinks(paragraph, index)
          )}
        </div>
      </div>
    </section>
  );
};
